import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FaqSection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/faq").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  return (
    <section data-testid="faq-section" className="max-w-3xl mx-auto px-6 pb-24">
      <p className="overline mb-3">Dudas comunes</p>
      <h2 className="font-display text-4xl sm:text-5xl text-white font-light tracking-tight mb-10">Preguntas Frecuentes</h2>
      <Accordion type="single" collapsible className="border-t border-white/10">
        {items.map((it, i) => (
          <AccordionItem key={it.id} value={it.id} className="border-white/10">
            <AccordionTrigger data-testid={`faq-question-${i}`}
              className="text-left text-base sm:text-lg text-zinc-100 hover:text-[#C9A25E] hover:no-underline py-5">
              {it.question}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${i}`} className="text-zinc-400 leading-relaxed whitespace-pre-wrap text-sm sm:text-base">
              {it.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
